import type { AchievementBadge } from '@/types/domain';

// User achievement badges — a separate system from producer trust badges
// ("Güvenilir Üretici" on the producer card).
export const achievementBadges: AchievementBadge[] = [
  {
    id: 'b1',
    name: 'Çiftçi Dostu',
    description: 'İlk yerli üreticiyle temas kurdun ve destekledin.',
    state: 'earned',
    tone: 'pink',
  },
  {
    id: 'b2',
    name: 'Piyasa Takipçisi',
    description: 'Günlük tarım piyasalarını 5 gün üst üste kontrol ettin.',
    state: 'earned',
    tone: 'amber',
  },
  {
    id: 'b3',
    name: 'Hasat Destekçisi',
    description: "Platformda 100 kg'dan fazla ürün alım anlaşması yaptın.",
    state: 'locked',
    tone: 'gray',
  },
];
